import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import StatCard from "./StatCard";
import { getRevenueSummary } from "../api/adminApi";
import "./admin-dashboard.css";

export default function Revenue() {
  const [rev, setRev]         = useState(null);
  const [loading, setLoading] = useState(true);

  const formatMoney = (n) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(n || 0);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await getRevenueSummary();
        if (!alive) return;
        setRev(data);
      } catch (err) {
        alert(err?.response?.data?.message || "Failed to load revenue");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => (alive = false);
  }, []);

  return (
    <div className="adm-layout">
      <Sidebar />
      <main className="adm-main">
        <div className="adm-shell">
          <Topbar title="Revenue" subtitle="Revenue summary & refunds" />

          {loading && <div style={{ padding: 10, color: "var(--muted-neutral)" }}>Loading...</div>}

          {rev && (
            <>
              <div className="adm-grid">
                <StatCard title="Revenue This Month"       value={formatMoney(rev.thisMonth)} tone="success" icon="📈" />
                <StatCard title="Revenue Last Month"       value={formatMoney(rev.lastMonth)} tone="primary" icon="📊" />
                <StatCard title="Total Revenue (All Time)" value={formatMoney(rev.allTime)}   tone="primary" icon="₹"  />
                <StatCard title="Refunds"                  value={formatMoney(rev.refunds)}   tone="warn"    icon="↩️" />
              </div>

              {/* Monthly breakdown table */}
              {rev.monthly?.length > 0 && (
                <div className="adm-panel" style={{ gridColumn: "span 12", marginTop: 24 }}>
                  <h3>Monthly Breakdown (Last 6 Months)</h3>
                  <table className="adm-table">
                    <thead>
                      <tr><th>Month</th><th>Revenue</th><th>Subscriptions</th></tr>
                    </thead>
                    <tbody>
                      {rev.monthly.map((m, i) => (
                        <tr key={i}>
                          <td>{m.month}</td>
                          <td>{formatMoney(m.revenue)}</td>
                          <td>{m.count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Plan-wise breakdown */}
              {rev.byPlan?.length > 0 && (
                <div className="adm-panel" style={{ gridColumn: "span 12", marginTop: 16 }}>
                  <h3>Revenue by Plan</h3>
                  <table className="adm-table">
                    <thead>
                      <tr><th>Plan</th><th>Subscriptions</th><th>Revenue</th></tr>
                    </thead>
                    <tbody>
                      {rev.byPlan.map((p, i) => (  
                        <tr key={i}>
                          <td>{p.plan}</td>
                          <td>{p.count}</td>
                          <td>{formatMoney(p.revenue)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
}

